import { Controller } from '@hotwired/stimulus';

import { createElement } from 'react';
import { createRoot } from 'react-dom/client';

import App from './thesis_edit/App';

export default class ThesisEditController extends Controller {
  static values = {
    props: Object
  };

  connect() {
    const element = createElement(App, this.propsValue);

    createRoot(this.element).render(element);
  }
}
